export default "__VITE_ASSET__DMoeXqNT__"